import React from 'react';
import styles from "../../refundStyles.module.scss";
import MultiSelectCellComponentWithSearch from 'views/pages/manage/common/commonComponents/SearchFilterView/MultiSelectCellComponentWithSearch';
import PencilIcon from "assets/img/svg/svgComponents/PencilIcon";
import { getFormattedDate, getFormattedTime } from '../../common/services';

const extractRefundConfigInfo = config => {
    const { businessArea = [], cashier = [], approvalSettingDTO = [], branchType = [] } = config;

    let refundTypes = [];
    let LEVEL_1 = new Set();
    let LEVEL_2 = new Set();
    let LEVEL_3 = new Set();

    approvalSettingDTO.forEach(cfg => {
        if (cfg?.subType) {
            refundTypes.push(cfg.subType);
        }

        (cfg?.roleApprovals?.LEVEL_1 || []).forEach(role => role != null && LEVEL_1.add(role));
        (cfg?.roleApprovals?.LEVEL_2 || []).forEach(role => role != null && LEVEL_2.add(role));
        (cfg?.roleApprovals?.LEVEL_3 || []).forEach(role => role != null && LEVEL_3.add(role));
    });

    return {
        refundTypes,
        businessArea: businessArea.filter(ba => ba != null),
        cashier: cashier.filter(c => c != null),
        branchType: branchType.filter(bt => bt != null),
        LEVEL_1,
        LEVEL_2,
        LEVEL_3,
        updatedOn: approvalSettingDTO[0]?.updatedOn,
        updatedBy: approvalSettingDTO[0]?.updatedBy,
        approvalConfigNumber: approvalSettingDTO[0]?.approvalConfigNumber
    };
};


const ConfigSummaryCard = ({
    config,
    editConfigHandler,
    isUpdatePermission
}) => {
    const { refundTypes, businessArea, cashier, LEVEL_1, LEVEL_2, LEVEL_3, updatedOn, updatedBy, approvalConfigNumber } = extractRefundConfigInfo(config);

    return (
        <div className={'d-flex flex-column justify-content-between ' + styles['config-summary-card']}>
            <div className={`d-flex flex-column ${styles['refund-card-header']}`}>
                <div className={`d-flex justify-content-between`}>
                    <MultiSelectCellComponentWithSearch data={refundTypes} title={'Refund Types'} />
                    {isUpdatePermission && <span onClick={() => editConfigHandler(config)} className={`${styles['edit-icon']}`}><PencilIcon /></span>}
                </div>
                <div className={styles['refund-number']}>Refund {approvalConfigNumber}</div>
            </div>
            <hr className='w-100' />
            <div>
                <div className={styles['label']}>ACTIVE IN {businessArea?.length} BRANCHES</div>
                <MultiSelectCellComponentWithSearch data={businessArea} title={"Business Areas"} />
            </div>

            <div>
                <div className={styles['label']}>ACTIVE IN {cashier?.length} CASHIER'S OFFICE</div>
                <MultiSelectCellComponentWithSearch data={cashier} title={"Business Areas"} />
            </div>

            <div className='d-flex justify-content-between'>
                <div>
                    <div className={styles['label']}>L1 ROLES</div>
                    <MultiSelectCellComponentWithSearch data={[...LEVEL_1]} title={"L1 Roles"} />
                </div>
                <div>
                    <div className={styles['label']}>L2 ROLES</div>
                    <MultiSelectCellComponentWithSearch data={[...LEVEL_2]} title={"L2 Roles"} />
                </div>
            </div>

            <div>
                <div className={styles['label']}>L3 ROLES</div>
                <MultiSelectCellComponentWithSearch data={[...LEVEL_3]} title={"L3 Roles"} />
            </div>

            <div className={styles['label']}>Last updated by {updatedBy} on {getFormattedDate(updatedOn)} at {getFormattedTime(updatedOn)}</div>

        </div>
    );
}

export default ConfigSummaryCard;